import { styled } from "@mui/material/styles";
import { Button, IconButton } from "@mui/material";

const DateMain = styled("div")(({ theme }) => ({
  position: "relative",
  width: "12%",
}));
const DateStyleBtn = styled(Button)(({ theme }) => ({
  background: "#FFFFFF",
  border: "1px solid #858585",
  borderRadius: "4px",
  padding: "5px",
  minWidth: "fit-content",
  fontStyle: "normal",
  fontWeight: 500,
  fontSize: "14px",
  lineHeight: "16px",
  color: "rgba(11, 11, 11, 0.5)",
  textTransform: "capitalize",
  fontFamily: theme.typography.fontFamily,
  width: "100%",
  height: "40px",
  "& img": {
    marginRight: "5px",
  },
  "& svg": {
    marginRight: "5px",
    fontSize: "20px",
  },
  "&:hover": {
    background: "#FFFFFF",
  },
}));

const DateWrapper = styled("div")(({ theme }) => ({
  position: "absolute",
  top: "50px",
  right: "0",
  zIndex: 99,
}));
const CleanButton = styled(IconButton)(({ theme }) => ({
  position: "absolute",
  top: "-8px",
  left: "90%",
  zIndex: 9,
  background: "red",
  color: "#fff",
  padding: 0,
  "& svg": {
    marginRight: "0px",
    fontSize: "17px",
  },
  "&:hover": {
    background: "red",
    color: "#fff",
  },
  "&.select_account_clean": {
    left: "98%",
  },
}));

export { DateStyleBtn, DateWrapper, CleanButton, DateMain };
